import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import {
  buildWaLink,
  openWhatsApp,
  WHATSAPP_NUMBERS,
} from "@/lib/constants";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="noise-overlay relative bg-navy-dark py-14 sm:py-16"
  >
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-10">
        <div className="max-w-md">
          <Logo dark />
          <p
            data-testid="footer-disclaimer"
            className="mt-5 text-xs sm:text-sm text-slate-400 leading-relaxed"
          >
            EY 58 Group menyediakan perkhidmatan konsultasi dan semakan awal
            kelayakan pembiayaan sahaja. Semakan ini bukan jaminan kelulusan;
            sebarang kelulusan adalah tertakluk pada penilaian pihak pembiaya
            yang berkenaan.
          </p>
        </div>

        <nav data-testid="footer-nav" className="flex flex-col gap-3">
          <p className="text-xs uppercase tracking-widest font-semibold text-gold">
            Pautan
          </p>
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="text-sm text-slate-300 transition-colors duration-200 hover:text-gold w-fit"
          >
            Polisi Privasi
          </Link>
          <a
            href={buildWaLink(WHATSAPP_NUMBERS[0])}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-contact-link"
            onClick={(e) => {
              e.preventDefault();
              openWhatsApp("footer");
            }}
            className="text-sm text-slate-300 transition-colors duration-200 hover:text-gold w-fit"
          >
            Hubungi Kami
          </a>
        </nav>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} EY 58 Group. Hak cipta terpelihara.
        </p>
        <p className="text-xs text-slate-500">
          Semakan percuma • Tanpa komitmen • Tiada bayaran pendahuluan
        </p>
      </div>
    </div>
  </footer>
);
